export const MAX_QUICK_ACTIONS = 8

/** Shown on the dashboard (and pre-ticked in the picker) while nothing is pinned; same list as mobile. */
export const DEFAULT_QUICK_ACTION_KEYS = ['ai-avatar', 'language-lab', 'visualize', 'xr', 'palj', 'assessments']

// One soft colour per tool, shared with the mobile Quick actions and Language Lab tiles.
export const QUICK_ACTION_TINT = {
  'ai-avatar': { bg: '#efe7ff', fg: '#6a1cf6' },
  'language-lab': { bg: '#dff5f2', fg: '#0f8a7e' },
  visualize: { bg: '#fde7f1', fg: '#d6336c' },
  xr: { bg: '#fff0e1', fg: '#e8590c' },
  palj: { bg: '#e3f0ff', fg: '#1c64d9' },
  assessments: { bg: '#e6f7ea', fg: '#2b8a3e' },
  catalog: { bg: '#ebe9ff', fg: '#4c3fd1' },
  progress: { bg: '#f1f3f9', fg: '#595c60' },
}
